import React from 'react'
import Header, { listImage } from '../../components/header/header'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import TitleSection from '../../components/title-section/title-section'
import ButtonTC from '../../components/button-tc/button-tc'
import styled from 'styled-components'
import SectionTC from '../../components/section-tc/section-tc'
import { ArrowIosDownward } from '@styled-icons/evaicons-solid'
import FeatureItem from '../landing/components/feature-item/feature-item'
import { listFeature } from '../landing/data'
import { device } from '../../config/theme/breakpoints'
import ItemDestiny from './components/item-destiny/item-destiny'
import { destinationsListitem } from './data-destinations'

const BodyHeaderContainer = styled.div`
  color: white;
  text-align: center;
  width: 100%;
  padding: 80px 0 50px;

  > div span{
    font-size: 12px;
  }

  @media ${device.tablet}{
    padding: 120px 0 50px;
  }
`
const PreTitle = styled.h3`
  font-style: italic;
  margin-bottom: 10px;
  font-weight: lighter;
  text-transform: uppercase;
  margin: 0;
  margin-top: 50px;
`
const Title = styled.h1`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 40px;
  text-transform: uppercase;
  position: relative;
  width: fit-content;
  margin: auto;
  padding-bottom: 5px;
  margin-bottom: 40px;
`
const TitleBar = styled.div`
    width: 30px;
    height: 7px;
    background: ${p => p.theme.palette.secondary.main};
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 6px 0 15px 6px;
    transform: skew(-30deg);
`

const ContainerDestinations = styled.div`
  width :100%;  
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  -webkit-box-pack: center;
  margin-bottom: 30px;
`

const FeatureCustomClass = `
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: 15px;
  padding-top: 5px;
  padding-bottom: 5px;

  @media ${device.mobileL}{
    justify-content: space-around;
  }
`

const Destinations: React.FunctionComponent = () => {
  const handleClick = () => {
    window.location.href = 'destinos/chiclayo'
  }
  
  return (
    <Layout>
        <Header images={listImage}>
          <BodyHeaderContainer>
            <SectionTC>
              <PreTitle>Viaja por el Perú</PreTitle>
              <Title>
                Con tarifas únicas
                <TitleBar />
              </Title>
              <span>Encuentra respuestas a todas tus preguntas sobre viajes relacionadas con la COVID-19 aquí</span>
            </SectionTC>
          </BodyHeaderContainer>
        </Header>
        <HeaderOptions>
          <SectionTC className={FeatureCustomClass}>
            {listFeature.map(feature => (
              <FeatureItem
                key={feature.id}
                icon={feature.icon}
                title={feature.title}
                subTitle={feature.subTitle}
                description={feature.description}
              />
            ))}
          </SectionTC>
        </HeaderOptions>
        <SectionTC withIconRight>
          <TitleSection preTitle='Principales destinos' title='Y promociones'/>
          <ContainerDestinations>
            {destinationsListitem.map(destiny => (
              <ItemDestiny
                  tour={destiny.tour}
                  price={destiny.price}
                  title={destiny.title}
                  subTitle={destiny.subTitle}
                  image={destiny.image}
                  onClick={handleClick}
                />
            ))}
          </ContainerDestinations>
          <ButtonTC text='Ver más destinos' icon={<ArrowIosDownward />} />
        </SectionTC>
        
    </Layout>
  )
}

export default Destinations